<template>
  <z-dialogo
    ref="dialogo"
    titulo="Fornecedores"
    scrollable
    dividers
    no-padding
    largura="1000px"
    altura="383px"
  >
    <template v-slot:prepend>
      <v-toolbar flat color="white">
        <v-text-field
          ref="busca"
          v-model="busca"
          outlined
          filled
          single-line
          dense
          label="Pesquisar"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          @keydown.enter="buscar"
          @focus="onBuscaFocus"
          @click:clear="limparBusca"
          @blur="is_busca_focused = false"
        ></v-text-field>
      </v-toolbar>
    </template>

    <template v-slot:conteudo>

      <v-card class="d-flex flex-column fill-height">
        <v-card-text class="pa-0 fill-height nice-scrollbar">
          <div ref="topo"></div>
          <v-data-table
            disable-pagination
            disable-sort
            hide-default-footer
            :headers="headers"
            :items="fornecedores"
            :loading="carregando"
          >

            <template v-slot:item="{ item: fornecedor, index }">
              <tr
                class="apontador noselect" 
                @click="selecionar(fornecedor)" 
              >
                <td>{{ fornecedor.id }}</td>
                <td>{{ fornecedor.razao }}</td>
                <td>{{ fornecedor.celular }}</td>
              </tr>
            </template>

          </v-data-table>
        </v-card-text>
      </v-card>
          
    </template>

    <template v-slot:actions_left>
      <span class="text-subtitle-2">Fornecedores encontrados: {{ fornecedores.length }}</span>
    </template>
    <template v-slot:actions_right>
      <v-btn depressed rounded color="primary" @click="fechar()">ESC - Fechar</v-btn>
    </template>
  </z-dialogo>
</template>

<script>
import fornecedoresApi from "@/app/services/fornecedores";

import { mapGetters } from "vuex";

import buscas_mixin from "@/app/mixins/buscas";

export default {
  name: "DialogoBuscarFornecedor",

  data() {
    return {
      fornecedores: [],
      busca: '',
      headers: [
        { text: "Código", value: "id", width: "100px" },
        { text: "Razão Social", value: "razao" },
        { text: "Celular", value: "celular" },
      ],
      carregando: false,
      selectedItem: 0,
      grupoSelecionado: {}
    };
  },


  computed: {
    ...mapGetters("listas", ["grupos"]),
  },

  methods: {
    async carregarGrupos() {
      await this.$store.dispatch("listas/grupos");
      this.grupos.unshift({
        text: 'Todos',
        value: 0
      })
    },

    async abrir(search = '') {
      if (search) {
        this.busca = search;
        this.buscar();
      }
      
      this.$refs.dialogo.abrir();
      this.setFocus("busca", 300);
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    async buscar(event) {
      try {
        if (event) {
          event.target.select();
        }

        this.carregando = true;
        this.fornecedores = await fornecedoresApi.buscar(this.busca);
      } catch (error) {
        this.$eventbus.erroSistema(error);
      } finally {
        this.carregando = false;
      }
    },

    selecionar(fornecedor) {
      this.$emit("selecionar:fornecedor", fornecedor);
      this.fechar();
    },

    onBuscaFocus(event) {
      console.log("onBuscaFocus");
      event.target.select(); 
      this.is_busca_focused = true;
    },

    limparBusca() {
      this.busca = "";
      this.fornecedores = [];
    },
  },
};
</script>

<style scoped></style>
